export default __webpack_public_path__ + "static/media/ora.dbe9ae28.png";